import type { ColoredIcon } from "../ColoredIcon.js";
import { SubscriptionVariant } from "../SubscriptionVariant.js";

export const subscriptionVariantIconMap: Record<SubscriptionVariant, ColoredIcon> = {
	[SubscriptionVariant.Espresso]: {
		color: "#777777",
		key: "cup",
	},
	[SubscriptionVariant.Filter]: {
		color: "#C56D2E",
		key: "mug",
	},
};
